import React from "react";

const Earnings = () => {
    return (
        <svg
            className="ml-auto mt-3"
            width="58"
            height="52"
            viewBox="0 0 62 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="61.622"
                height="56.6929"
                rx="6"
                fill="#F89B96"
                fill-opacity="0.2"
            />
            <g clip-path="url(#clip0_1_689)">
                <path
                    d="M35.6875 9.76242C34.859 8.95898 33.5761 8 32.1719 8C29.8934 8 27.9342 10.5245 27.719 10.813C27.5884 10.987 27.5089 11.1939 27.4893 11.4106C27.4697 11.6273 27.5108 11.8451 27.608 12.0398L31.4475 19.7969H39.9271L43.7671 12.0398C43.8644 11.8451 43.9055 11.6273 43.8859 11.4106C43.8663 11.1939 43.7867 10.987 43.6561 10.813C43.4409 10.5245 41.4817 8 39.2032 8C37.7989 8 36.516 8.95898 35.6875 9.76242ZM36.8594 22.1406V22.342C36.8594 24.1399 37.5884 25.9 38.8598 27.1714C39.3175 27.6291 39.3175 28.3708 38.8598 28.8285C38.4021 29.2863 37.6604 29.2863 37.2027 28.8285C36.6042 28.2312 36.096 27.5525 35.6875 26.8189C35.2789 27.5525 34.7708 28.2311 34.1722 28.8285C33.7145 29.2863 32.9728 29.2863 32.5151 28.8285C32.0574 28.3708 32.0574 27.6291 32.5151 27.1714C33.7867 25.9 34.5157 24.1399 34.5157 22.342V22.1406H30.1249C27.4218 24.6954 24.7397 28.1677 22.9413 31.5156H33.3438C35.2824 31.5156 36.8594 33.0927 36.8594 35.0312V46.8281C36.8594 47.2435 36.7743 47.6298 36.6414 48H38.2029C44.9511 48 51 46.4955 51 39.7188C51 34.2971 45.7123 26.5799 41.167 22.1406H36.8594Z"
                    fill="#EB6868"
                />
                <path
                    d="M22.7969 42.0625C23.4441 42.0625 23.9688 41.5378 23.9688 40.8906C23.9688 40.2434 23.4441 39.7188 22.7969 39.7188C22.1497 39.7188 21.625 40.2434 21.625 40.8906C21.625 41.5378 22.1497 42.0625 22.7969 42.0625Z"
                    fill="#EB6868"
                />
                <path
                    d="M12.1719 48H33.3438C33.9915 48 34.5156 47.4759 34.5156 46.8281V35.0312C34.5156 34.3835 33.9915 33.8594 33.3438 33.8594H12.1719C11.5241 33.8594 11 34.3835 11 35.0312V46.8281C11 47.4759 11.5241 48 12.1719 48ZM29.8281 39.7188C30.4753 39.7188 31 40.2433 31 40.8906C31 41.5378 30.4753 42.0625 29.8281 42.0625C29.1809 42.0625 28.6562 41.5378 28.6562 40.8906C28.6562 40.2433 29.1809 39.7188 29.8281 39.7188ZM22.7969 37.375C24.7355 37.375 26.3125 38.952 26.3125 40.8906C26.3125 42.8292 24.7355 44.4062 22.7969 44.4062C20.8583 44.4062 19.2812 42.8292 19.2812 40.8906C19.2812 38.952 20.8583 37.375 22.7969 37.375ZM15.7656 39.7188C16.4128 39.7188 16.9375 40.2433 16.9375 40.8906C16.9375 41.5378 16.4128 42.0625 15.7656 42.0625C15.1184 42.0625 14.5938 41.5378 14.5938 40.8906C14.5938 40.2433 15.1184 39.7188 15.7656 39.7188Z"
                    fill="#EB6868"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_689">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(11 8)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Earnings;